import { User } from '@interface/user.interfaces'; // Use @interface alias
import { AvatarComponent } from '@shared/avatar/avatar.component'; // Use @shared alias
import { LoginService } from '@service/auth-service/login.service'; // Use @service alias
import { Component, Input, OnInit } from '@angular/core';
import { NgIf } from '@angular/common';

@Component({
  selector: 'app-user-avatar',
  imports: [AvatarComponent, NgIf],
  standalone: true,
  templateUrl: './user-avatar.component.html'
})
export class UserAvatarComponent implements OnInit {
  @Input() size: 'small' | 'medium' | 'large' = 'medium';
  @Input() user: Partial<User> | null = null; // Changed type to Partial<User>

  constructor(private loginService: LoginService) {}

  ngOnInit() {
    // If a user object is passed as an input, use it directly.
    // Otherwise, subscribe to the LoginService's authUser$ observable.
    // The 'user' input takes precedence.
    if (!!this.user) {
      // User is already provided via input, no need to subscribe
    } else {
      this.loginService.authUser$.subscribe(user => {
        this.user = user;
      });
    }
  }
}